<template>
    <section>
        <div class="titulo">
            <div class="margem container" style="align-items:flex-end;">
                <h2>Painel de Recursos de Orçamento</h2>
            </div>
        </div>
        <div class="margem container">
            <div class="bloco margem">
                <fieldset class="grid-4" style="margin: 0 0 1rem 0;">
                    <div>
                        <label>Ano / Exercício: </label>
                        <select v-model="anoSelecionado">
                            <option value="" disabled>Selecione</option>
                            <option v-for="item in anos" :key="item" :value="item"> {{ item }} </option>
                        </select>
                    </div>
                    <div>
                        <label>Setor Executor: </label>
                        <input type="text" :value="setorAtual.nome" disabled />
                    </div>
                    <!-- <div class="alinha-centro" style="align-items:flex-end;">
                        <button class="acao-secundaria botao-pequeno" @click="limparFiltros"> Limpar </button>
                    </div> -->
                </fieldset>
            </div>
            <div class="bloco margem" v-if="categoriaResumo">
                <h3 class="alinha-centro">{{ categoriaResumo.descricao }}</h3>
                <div class="cards-resumo">
                    <div class="card-resumo" style="border-color: var(--cor-primaria);">
                        <span class="label">Previsto</span>
                        <strong>{{ formatarMoeda(categoriaResumo.valorPrevisto) }}</strong>
                    </div>
                    <div class="card-resumo" style="border-color: var(--cor-erro);">
                        <span class="label">Gasto</span>
                        <strong>{{ formatarMoeda(categoriaResumo.valorGasto) }}</strong>
                    </div>
                    <div class="card-resumo" style="border-color: var(--cor-sucesso);">
                        <span class="label">Saldo</span>
                        <strong>{{ formatarMoeda(categoriaResumo.saldo) }}</strong>
                    </div>
                    <div class="card-resumo porcentagem">
                        <span class="label">% Utilizado</span>
                        <strong>{{ categoriaResumo.percentualUtilizado.toFixed(1) }}%</strong>
                    </div>
                </div>
            </div>
            <div class="bloco margem">
                <div class="table-container">
                    <table class="tabela">
                        <thead>
                            <tr>
                                <th class="header">Categoria</th>
                                <th class="header valor-col">Previsto</th>
                                <th class="header valor-col">Gasto</th>
                                <th class="header valor-col">Saldo</th>
                                <th class="header">Utilização</th>
                                <th class="header acao-col">Complementação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="categoriasCalculadas.length === 0">
                                <td colspan="6" style="text-align:center; font-size:0.9rem;"> Nenhuma categoria
                                    encontrada para o ano selecionado. </td>
                            </tr>
                            <tr v-for="cat in categoriasCalculadas" :key="cat.id" @click="selecionarCategoria(cat)"
                                :class="{ 'linha-selecionada': cat.id === categoriaSelecionadaId }"
                                style="cursor:pointer;">
                                <td>
                                    <strong>{{ cat.descricao }}</strong>
                                </td>
                                <td class="valor-col"> {{ formatarMoeda(cat.valorPrevisto) }} </td>
                                <td class="valor-col"> {{ formatarMoeda(cat.valorGasto) }} </td>
                                <td class="valor-col"> {{ formatarMoeda(cat.saldo) }} </td>
                                <td>
                                    <div class="progresso-wrapper">
                                        <div class="progresso-barra">
                                            <div class="progresso-preenchido"
                                                :style="{ width: cat.percentualUtilizado + '%' }"></div>
                                        </div>
                                        <span class="progresso-label"> {{ cat.percentualUtilizado.toFixed(1) }}% </span>
                                    </div>
                                </td>
                                <td class="acao-col">
                                    <button class="acao-secundaria botao-pequeno"
                                        @click.stop="abrirModalComplemento(cat)"> Solicitar Complemento </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="bloco margem">
                <div class="cabecalho-bloco-solicitacoes">
                    <h3 class="alinha-centro">Solicitações de Complementação</h3>
                </div>
                <div class="cards-resumo" style="margin-bottom:0.75rem;">
                    <div class="card-resumo" style="border-color: var(--cor-primaria);">
                        <span class="label">Total</span>
                        <strong>{{ resumoSolicitacoes.total }}</strong>
                    </div>
                    <div class="card-resumo" style="border-color: #ffc107;">
                        <span class="label">Pendentes</span>
                        <strong>{{ resumoSolicitacoes.pendentes }}</strong>
                    </div>
                    <div class="card-resumo" style="border-color: #28a745;">
                        <span class="label">Aprovadas</span>
                        <strong>{{ resumoSolicitacoes.aprovadas }}</strong>
                    </div>
                    <div class="card-resumo" style="border-color: #dc3545;">
                        <span class="label">Reprovadas</span>
                        <strong>{{ resumoSolicitacoes.reprovadas }}</strong>
                    </div>
                </div>
                <div class="table-container">
                    <table class="tabela">
                        <thead>
                            <tr>
                                <th>Data</th>
                                <th>Categoria</th>
                                <th>Valor Solicitado</th>
                                <th>Justificativa</th>
                                <th>Status</th>
                                <th class="acao-col">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="solicitacoesFiltradas.length === 0">
                                <td colspan="6" style="text-align:center; font-size:0.9rem;"> Nenhuma solicitação
                                    registrada com os filtros atuais. </td>
                            </tr>
                            <tr v-for="sol in solicitacoesFiltradas" :key="sol.id">
                                <td>{{ formatarData(sol.dataSolicitacao) }}</td>
                                <td>{{ sol.categoria.descricao }}</td>
                                <td>{{ formatarMoeda(sol.valorSolicitado) }}</td>
                                <td class="justificativa-col"> {{ sol.justificativa }} </td>
                                <td class="status-col">
                                    <span :class="['tag-status', sol.status.toLowerCase()]"> {{ sol.status }} </span>
                                </td>
                                <td class="acao-col">
                                    <button class="acao-secundaria botao-pequeno"
                                        @click.stop="abrirModalDetalheSolicitacao(sol)"> Detalhes </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-mask" v-if="mostrarModalDetalheSolicitacao && solicitacaoDetalhe"
                @click.self="fecharModalFora">
                <div class="jm margem" style="min-width: 30vw">
                    <div class="alinha-centro">
                        <h3>Detalhes da solicitação</h3>
                    </div>
                    <div class="modal-body">
                        <div>
                            <label> <strong>Categoria:</strong> {{ solicitacaoDetalhe.categoria.descricao }} </label>
                            <label> <strong>Data:</strong> {{ formatarData(solicitacaoDetalhe.dataSolicitacao) }}
                            </label>
                            <label><strong>Valor Solicitado:</strong> {{
                                formatarMoeda(solicitacaoDetalhe.valorSolicitado) }}</label>
                            <label><strong>Status:</strong> <span
                                    :class="['tag-status', solicitacaoDetalhe.status.toLowerCase()]"> {{
                                        solicitacaoDetalhe.status }} </span></label>
                            <label><strong>Justificativa: </strong> {{ solicitacaoDetalhe.justificativa }} </label>
                        </div>
                        <br>
                        <hr v-if="solicitacaoDetalhe.observacaoGestor">
                        <div>
                            <br>
                            <div v-if="solicitacaoDetalhe.observacaoGestor" class="alinha-centro">
                                <label class="alinha-centro"><strong>Observação do sobre a solicitação: </strong>
                                </label>
                                <span class="campo-texto observacao-gestor"> {{ solicitacaoDetalhe.observacaoGestor }}
                                </span>
                            </div>
                        </div>
                        <div class="direita margem submit">
                            <button class="acao-secundaria" @click="fecharModalDetalheSolicitacao">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-mask" v-if="mostrarModalComplemento" @click.self="fecharModalFora">
                <div class="jm margem" style="min-width: 30vw">
                    <div class="alinha-centro">
                        <h3>Solicitar complemento de Orçamento</h3>
                        <h4> {{ categoriaSelecionadaParaComplemento.descricao }} </h4>
                    </div>
                    <div class="modal-body">
                        <fieldset class="grid-1">
                            <div>
                                <label>Valor</label>
                                <input type="text" v-model="formComplemento.valorSolicitado" />
                            </div>
                            <div>
                                <label>Justificativa</label>
                                <textarea rows="3" v-model="formComplemento.justificativa"></textarea>
                            </div>
                        </fieldset>
                        <div class="direita margem submit">
                            <button class="acao-secundaria" @click="fecharModal">Cancelar</button>
                            <button @click="salvarSolicitacaoComplemento"
                                :disabled="!formComplemento.valorSolicitado || !formComplemento.justificativa"> Enviar
                                solicitação </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'PainelRecursosView',
    data() {
        const anoAtual = new Date().getFullYear()

        return {
            anos: [anoAtual - 1, anoAtual, anoAtual + 1],
            anoSelecionado: anoAtual,

            setorAtual: {
                id: 1,
                nome: 'Setor de Manutenção'
            },

            dadosOrcamento: [
                {
                    ano: anoAtual,
                    setorId: 1,
                    categorias: [
                        {
                            id: 10,
                            descricao: '2.1.1 - Materiais de Consumo',
                            valorPrevisto: 50000,
                            valorGasto: 27500
                        },
                        {
                            id: 11,
                            descricao: '2.2.2 - Serviços de Terceiros',
                            valorPrevisto: 30000,
                            valorGasto: 9000
                        },
                        {
                            id: 12,
                            descricao: '2.3.3 - Equipamentos',
                            valorPrevisto: 80000,
                            valorGasto: 65000
                        }
                    ]
                },
                {
                    ano: anoAtual - 1,
                    setorId: 1,
                    categorias: [
                        {
                            id: 20,
                            descricao: 'Materiais de Consumo',
                            valorPrevisto: 45000,
                            valorGasto: 44000
                        }
                    ]
                }
            ],
            categoriaSelecionadaId: null,
            solicitacoesComplemento: [
                {
                    id: 1,
                    categoria: { id: 10, descricao: 'Materiais de Consumo' },
                    valorSolicitado: 5000,
                    justificativa:
                        'Reposição de insumos utilizados em manutenções corretivas emergenciais.',
                    status: 'Pendente',
                    observacaoGestor: null,
                    dataSolicitacao: new Date(anoAtual, 0, 12).toISOString()
                },
                {
                    id: 2,
                    categoria: { id: 12, descricao: 'Equipamentos' },
                    valorSolicitado: 20000,
                    justificativa:
                        'Aquisição de equipamento para aumentar a disponibilidade de máquinas.',
                    status: 'Aprovado',
                    observacaoGestor:
                        'Aprovado integralmente. Priorizar compra até o próximo mês.',
                    dataSolicitacao: new Date(anoAtual, 2, 3).toISOString()
                },
                {
                    id: 3,
                    categoria: { id: 11, descricao: 'Serviços de Terceiros' },
                    valorSolicitado: 8000,
                    justificativa:
                        'Contratação de empresa especializada em manutenção preventiva.',
                    status: 'Reprovado',
                    observacaoGestor:
                        'Reprovado devido à limitação orçamentária no período.',
                    dataSolicitacao: new Date(anoAtual - 1, 8, 25).toISOString()
                }
            ],

            filtroStatus: '',
            buscaSolicitacao: '',

            mostrarModalComplemento: false,
            categoriaSelecionadaParaComplemento: null,
            formComplemento: {
                valorSolicitado: null,
                justificativa: ''
            },

            mostrarModalDetalheSolicitacao: false,
            solicitacaoDetalhe: null
        }
    },

    computed: {
        registroAnoSetor() {
            return (
                this.dadosOrcamento.find(
                    r => r.ano === this.anoSelecionado && r.setorId === this.setorAtual.id
                ) || { categorias: [] }
            )
        },

        categoriasCalculadas() {
            return this.registroAnoSetor.categorias.map(c => {
                const saldo = c.valorPrevisto - c.valorGasto
                const perc = c.valorPrevisto > 0 ? (c.valorGasto / c.valorPrevisto) * 100 : 0

                return {
                    ...c,
                    saldo,
                    percentualUtilizado: Math.min(perc, 999)
                }
            })
        },

        categoriaResumo() {
            if (!this.categoriaSelecionadaId) return null

            const cat = this.categoriasCalculadas.find(
                c => c.id === this.categoriaSelecionadaId
            )

            return cat || null
        },

        solicitacoesOrdenadas() {
            return [...this.solicitacoesComplemento].sort(
                (a, b) => new Date(b.dataSolicitacao) - new Date(a.dataSolicitacao)
            )
        },

        solicitacoesFiltradas() {
            return this.solicitacoesOrdenadas.filter(sol => {
                if (this.filtroStatus && sol.status !== this.filtroStatus) return false

                if (this.buscaSolicitacao) {
                    const termo = this.buscaSolicitacao.toLowerCase()
                    const categoria = sol.categoria.descricao.toLowerCase()
                    const justificativa = sol.justificativa.toLowerCase()
                    return categoria.includes(termo) || justificativa.includes(termo)
                }

                return true
            })
        },

        resumoSolicitacoes() {
            const total = this.solicitacoesFiltradas.length
            let pendentes = 0
            let aprovadas = 0
            let reprovadas = 0

            this.solicitacoesFiltradas.forEach(sol => {
                const st = sol.status.toLowerCase()
                if (st === 'pendente') pendentes++
                if (st === 'aprovado') aprovadas++
                if (st === 'reprovado') reprovadas++
            })

            return {
                total,
                pendentes,
                aprovadas,
                reprovadas
            }
        }
    },

    methods: {
        limparFiltros() {
            this.categoriaSelecionadaId = null
        },

        selecionarCategoria(cat) {
            this.categoriaSelecionadaId =
                this.categoriaSelecionadaId === cat.id ? null : cat.id
        },

        formatarMoeda(valor) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(valor || 0)
        },

        formatarData(dataIso) {
            const d = new Date(dataIso)
            return d.toLocaleDateString('pt-BR')
        },

        abrirModalComplemento(categoria) {
            this.categoriaSelecionadaParaComplemento = categoria
            this.formComplemento.valorSolicitado = null
            this.formComplemento.justificativa = ''
            this.mostrarModalComplemento = true
        },

        fecharModal() {
            this.mostrarModalComplemento = false
        },

        salvarSolicitacaoComplemento() {
            const novaSolicitacao = {
                id: Date.now(),
                categoria: {
                    id: this.categoriaSelecionadaParaComplemento.id,
                    descricao: this.categoriaSelecionadaParaComplemento.descricao
                },
                valorSolicitado: this.formComplemento.valorSolicitado,
                justificativa: this.formComplemento.justificativa,
                status: 'Pendente',
                observacaoGestor: null,
                dataSolicitacao: new Date().toISOString()
            }

            this.solicitacoesComplemento.push(novaSolicitacao)
            this.mostrarModalComplemento = false
        },

        abrirModalDetalheSolicitacao(solicitacao) {
            this.solicitacaoDetalhe = solicitacao
            this.mostrarModalDetalheSolicitacao = true
        },

        fecharModalDetalheSolicitacao() {
            this.mostrarModalDetalheSolicitacao = false
            this.solicitacaoDetalhe = null
        },

        fecharModalFora() {
            if (this.mostrarModalComplemento) this.mostrarModalComplemento = false
            if (this.mostrarModalDetalheSolicitacao) this.mostrarModalDetalheSolicitacao = false
        }
    }
}
</script>
<style scoped>
.table-container {
    overflow-x: auto;
}

.acao-col {
    text-align: center;
}

.cards-resumo {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.75rem;
    font-size: 0.9rem;
    text-align: center;
    max-width: 900px;
    margin: 0 auto;
}

.card-resumo {
    border: 1px solid var(--cor-separador);
    border-radius: 8px;
    padding: 0.5rem 0.75rem;
    background-color: var(--cor-bg);
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    min-width: 150px;
}

.card-resumo .label {
    font-size: 0.8rem;
    color: var(--cor-texto-suave);
}

.card-resumo strong {
    font-size: 1rem;
}

.card-resumo.porcentagem strong {
    color: var(--cor-primaria);
}

.progresso-wrapper {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.progresso-barra {
    flex: 1;
    height: 8px;
    border-radius: 4px;
    background-color: var(--cor-separador);
    overflow: hidden;
}

.progresso-preenchido {
    height: 100%;
    background-color: var(--cor-primaria);
    transition: width 0.3s ease;
}

.progresso-label {
    font-size: 0.8rem;
}

.tag-status {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 0.75rem;
}

.tag-status.pendente {
    background-color: var(--cor-alerta);
    color: #000000;
}

.tag-status.aprovado {
    background-color: var(--cor-sucesso);
    color: #ffffff;
}

.tag-status.reprovado {
    background-color: var(--cor-erro);
    color: #ffffff;
}

.justificativa-col {
    max-width: 260px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.observacao-gestor {
    border-left: 3px solid var(--cor-primaria);
}




.botao-pequeno {
    font-size: 0.8rem;
    padding: 4px 16px;
    height: 28px;
    border-radius: 6px;
    cursor: pointer;
}
</style>
